import imprint from '@/static/assets/imprint/imprint-board.png';
import { font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import parse from 'html-react-parser';
import Image from 'next/image';
import type React from 'react';
import styled from 'styled-components';
import { MainHeader, Section } from '../shared/Content';

const Title = styled(MainHeader)`
  ${font('alt', { fontSize: '2.4rem' })};
  margin-bottom: 60px;
  ${MEDIA_QUERIES.tabletAndDesktop`
    ${font('alt', { fontSize: '3.6rem' })};
    white-space: pre;
    margin-bottom: 80px;
  `}
`;

export interface HeroProps {
  title?: string;
}

export const Hero: React.FC<HeroProps> = ({ title }) => {
  return (
    <Section pt={title != null ? [40, 70] : [0, 50]}>
      {title != null && <Title>{parse(title)}</Title>}
      <Image src={imprint} alt="" layout="responsive" />
    </Section>
  );
};
